import sign from "./sign.js"; // 登录相关
import user from "./user.js"; //用户信息
import trade from "./trade.js"; //项目
import my from "./my.js"; //我的
import apply from "./apply.js"; //我的
// 其他模块的接口……

// 导出接口
export default {
    sign,
    user,
    my,
    trade,
    apply,
};